import { IEvent } from "modules/event/types";

export const getGoogleCalendarLink = (
  event: IEvent,
  inviteLink: string,
  startDateStr: string,
  endDateStr: string,
  timezone: string,
): string =>
  [
    "https://calendar.google.com/calendar/render?action=TEMPLATE",
    `&dates=${startDateStr}/${endDateStr}`,
    `&location=${encodeURIComponent(inviteLink)}`,
    `&text=${encodeURIComponent(event.name || "")}`,
    `&details=${encodeURIComponent(event.shortDescription || "")}`,
    `&ctz=${encodeURIComponent(timezone)}`,
  ].join("");
export const getYahooCalendarLink = (
  event: IEvent,
  inviteLink: string,
  startDateStr: string,
  endDateStr: string,
): string =>
  [
    "https://calendar.yahoo.com/?v=60&view=d&type=20",
    `&title=${encodeURIComponent(event.name || "")}`,
    `&desc=${encodeURIComponent(event.shortDescription || "")}`,
    `&st=${startDateStr}`,
    `&et=${endDateStr}`,
    `&in_loc=${encodeURIComponent(inviteLink)}`,
  ].join("");
export const getICSCalendarLink = (
  event: IEvent,
  inviteLink: string,
  startDateStr: string,
  endDateStr: string,
  isMobile: boolean,
): string => {
  const link = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "BEGIN:VEVENT",
    `URL:${window.location}`,
    "METHOD:PUBLISH",
    `DTSTART:${startDateStr}`,
    `DTEND:${endDateStr}`,
    `SUMMARY:${event.name}`,
    `DESCRIPTION:${event.shortDescription || ""}`,
    `LOCATION:${inviteLink}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\n");

  return isMobile ? encodeURI(`data:text/calendar;charset=utf8,${link}`) : link;
};
